export default "__VITE_ASSET__880c5eb7__"